import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { connect } from 'react-redux';
import { CallbackComponent, processSilentRenew } from 'redux-oidc';
import { useNavigate } from 'react-router-dom';
import { UserManager } from 'oidc-client';
//import { API_IDENTITY_URI, APP_REDIRECT_URL, APP_SILENT_REDIRECT_URL } from './api2';

const userManagerConfig = {
    client_id: 'cscore_vanhanh_spa_mt',
    client_id_dev: 'cscore_vanhanh_spa_mt',
    client_id_langson: 'spa_mt_staging_2',
    client_id_nhaplieu: 'spa_nhaplieu',
   // redirect_uri: APP_REDIRECT_URL,
    response_type: 'token id_token',
    scope: 'openid profile CSCoreApi CSCore_NghiepVu_Api CSCore_DMS_Api CSCore_Spatial_Api CSCore_Ocelot_ApiGateway',
    //authority: API_IDENTITY_URI,
   // silent_redirect_uri: APP_SILENT_REDIRECT_URL,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: false,
};

export const userManager = new UserManager(userManagerConfig);

function CallBack(props) {
    let navigate = useNavigate();

    const successCallback = () => {
        var link = localStorage.getItem('CSCORE_LINK');
        if (link !== '/') {
            navigate(link);
        } else {
            navigate('/');
        }
    };

    const errorCallback = (err) => {};

    return (
        <CallbackComponent userManager={userManager} successCallback={successCallback} errorCallback={errorCallback}>
            <div className="flat">
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        </CallbackComponent>
    );
}

const mapStateToProps = (state) => ({
    oidc: state.oidc.user,
});

export const OidcCallBack = connect(mapStateToProps)(CallBack);

export class OidcSilentRenew extends React.Component {
    componentDidMount() {
        processSilentRenew();
    }
    render() {
        return null;
    }
}
